import client from '../apiClient';

export async function storage(data) {
    let response = await client.post('productRepertoryRecord/storage' , data)
    return response
}